<template>
  <div>
    <div @click="isOpen = !isOpen">
      <slot name="handle"></slot>
    </div>

    <div v-show="isOpen">
      <slot name="dropdown"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      closeAlways: true
    };
  },

  created() {
    let handler = event => {
      if (!this.$el.contains(event.target) && this.isOpen) {
        this.isOpen = false;
      }
    };

    document.addEventListener("click", handler);

    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("click", handler);
    });
  }
};
</script>